<template lang="pug">
v-container 
    v-dialog(v-model="IsShowModalInsert"   width="500")
        v-card
                v-card-title(class="elevation-1") 
                    | Ingresar   
                    v-spacer
                    v-btn(icon @click="IsShowModalInsert=false")   
                        v-icon mdi-close
                v-container( fluid)
                    v-row
                        v-col(v-for="item in ListField" cols="12" sm="12" md="12" )
                            v-text-field(v-if="item.FieldType=='TextBox' " v-model="item.value" :label="item.FieldName")
                            v-text-field(v-else-if="item.FieldType=='Date' " v-model="item.value" type="date" :label="item.FieldName")
                            v-text-field(v-else-if="item.FieldType=='NumeberBox' " v-model="item.value" type="number" :label="item.FieldName")
                            v-autocomplete( v-else-if="item.FieldType=='Select' && item.BaseIdDocListSelect==0 "  
                                            :label="item.FieldName"
                                            :items="ListFieldSelect.filter(b => b.IdDocListSelect==item.IdDocListSelect)"
                                            item-text="Text"
                                            item-value="Text"                                     
                                            v-model="item.value"
                                            )
                            v-autocomplete( v-else-if="item.FieldType=='Select' && item.BaseIdDocListSelect!=0 "  
                                            :label="item.FieldName"
                                            :items="ListFieldSelect.filter(b => b.IdDocListSelect==item.IdDocListSelect)"
                                            item-text="Text"
                                            item-value="Text"
                                            v-model="item.value"
                                            
                                            
                                            )
                    v-row
                        v-col(cols="12" sm="12" md="12" )
                            v-btn(color="primary" @click="Insert()") Guardar
    v-card( style="background-color:indigo!important  ")  
        v-sheet( elevation="6") 
            v-tabs(v-model='IsTabs'  
                    fixed-tabs
                    background-color="indigo"
                    dark
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows
                    )
                        v-tabs-slider(color="yellow")
                        v-tab(v-for="item in listDocument" style="color:white!important" :key='item.IdDocType' @click="List_Info(item.IdDocType)").text-white.primary--text {{item.Name}}
                            v-icon mdi-file-edit-outline  
            v-tabs-items(v-model='IsTabs')
                v-tab-item(v-for='item in listDocument' :key='item.IdDocType' )
                    v-card(flat='')
                        v-card-title()
                            h4 {{item.Name}}
                            v-spacer 
                            v-btn(color="primary" @click="IsShowModalInsert=true") Nuevo
                        v-container(fluid)
                            v-data-table(      
                                id="DocumentoTabla" 
                                :headers="tableHeadTest"                 
                                :items="tableInfo"
                                :items-per-page="50"
                                class="elevation-1"
                                style="font-size: 14px;" ) 

                                template( v-slot:item.numero="{ item }")
                                    v-btn(icon color="warning" @click="Delete_Lista(item.idDocument,item.numero)")
                                        v-icon.fa.fa-trash-o 
         
</template>
<script> 
import apiWeb from "../../api/apiSLC.js"
import model from "../../models/goalMaintainerSSO.js" 
import formInsert from './components/insert.vue'
import formUpdate from './components/update.vue'
import formView from './components/view.vue'
import formViewDetails from './components/viewDetails.vue'
export default {
    components:{
                formInsert,
                formUpdate,
                formView,
                formViewDetails
    },
    data(){
        return{

                nameModulo:'Documentos',
                pathApi:'DocumentType/DocumentType',
                selectEnterprise:'0',
                tableEnterprise:[],
                IsShowModalInsert:false,
                IsShowModalUpdate:false,
                IsShowModalConfig:false,
                IsShowModalViewDetails:false,
                listDocument:'hola aasda',
                IsTabs:null,
                InfoUser:[],
                ListField:[],
                SelectIdDocType:0,
                ListFieldSelect:[],
                InfoDocument:[],
                InfoCategory:[],
                InfoFrecuncy:[],
                InfoPeriod:[],
                ItemSelect:{},
                parameterUpdate:Object.assign({}, model.parameterUpdate),
                parameterInsert:Object.assign({}, model.parameterInsert),
                parameterView:Object.assign({}, model.parameterView),
                tableInfo:[],
                tableHeadTest:[],
                tableHead:[],
                tableInfoGroup:[],
                tableInfoSelect:[],
                IsShowEnterprise:false
        }
    }, 
    created(){ 
        if(this.$info.idEnterprise==1 && this.$info.typeAccount==4){
            this.List_Enterprise()
            this.IsShowEnterprise=true
        }
        else{
            this.IsShowEnterprise=false
            this.selectEnterprise=this.$info.idEnterprise
        }
        this.Get_ListDocument()
        this.setValueInit()  
    },
    methods:{     
         
        List_Info(IdDocType_){      
            this.SelectIdDocType=IdDocType_
            this.List_Field(IdDocType_)
            this.List_Field_Select(IdDocType_)
            console.log(IdDocType_)         
            apiWeb.get("Report/ReportDocument/" + IdDocType_,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.tableHeadTest=[]
                                    this.tableInfo=JSON.parse(JSON.stringify(result.value))  
                                    if( this.tableInfo.length>0)
                                    {
                                       this.tableHead=Object.keys(this.tableInfo[0])     
                                       this.tableHead.forEach(element => { 
                                            if(element!='idDocument' && element!='errorSendEmail' && element!='sendEmail' && element!='questions' && element!='category') 
                                                this.tableHeadTest.push({text: element.capitalize(), value:element})
                                       });
                                       
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Field(IdDocType_){      
            console.log(IdDocType_)   
            var formSend={
                IdEnterprise:this.selectEnterprise,
                IdDocType:IdDocType_
            }      
            console.log(formSend)  
            apiWeb.post("DocumentType/DocumentType_ListField",formSend)
                    .then(result=>{
                                if(result.status==0){
                                    
                                    this.ListField=JSON.parse((result.value))  
                                                            
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Field_Select(IdDocType_){      
            console.log(IdDocType_)   
            var formSend={
                IdEnterprise:this.selectEnterprise,
                IdDocType:IdDocType_
            }      
            console.log(formSend)  
            apiWeb.post("DocumentType/DocumentType_ListField_Select",formSend)
                    .then(result=>{
                                if(result.status==0){
                                    
                                    this.ListFieldSelect=JSON.parse((result.value))  
                                                            
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Get_InfoUser(){
            var params={
                IdEnterprise:this.selectEnterprise,
                NameUser:'',
                Email:'',
                Active:1
            }
            apiWeb.post("Users/Users_View",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoUser=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Get_ListDocument(){
            var params={
                IdEnterprise:this.selectEnterprise,
                Name:'', 
                Active:1
            }
            apiWeb.post("DocumentType/DocumentType_ListDocument",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.listDocument=JSON.parse(result.value) 
                                    console.log(this.listDocument)                                   
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },   
        Get_Document(){
            var params={
                IdEnterprise:this.selectEnterprise,
                Name:'', 
                Active:1
            }
            apiWeb.post("DocumentType/DocumentType_View",params)
                    .then(result=>{
                                if(result.status==0){ 
                                    this.InfoDocument=JSON.parse(result.value)                                    
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Delete_Lista(id,n){
                this.$msgbox.confirm("Esta Seguro de eliminar el documento : " + n + " ?","Aviso")
                            .then(r=>{
                                if(r){
                                       apiWeb.get("Report/DeleteDocument/"+ id,"")
                    .then(result=>{
                                    if(result.status==0){
                                        this.List_Info(this.SelectIdDocType)                             
                                                                    
                                    }
                                    else{
                                        this.$msgbox.show(result.message,"Error nivel 1")
                                    }
                                })
                                .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")}) 
                                            }
                                        })
        },  
         
        List_Enterprise(){
            apiWeb.post("Enterprise/Enterprise_View",{ RUT:'',BusinessName:'',Active:'1'})
                    .then(result=>{
                                if(result.status==0){ 
                                    this.tableEnterprise=JSON.parse(result.value)
                                    if(this.selectEnterprise=='' && this.tableEnterprise.length>0)
                                        this.selectEnterprise=this.tableEnterprise[0].IdEnterprise
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        setValueInit(){            
            this.parameterView.IdEnterprise=this.selectEnterprise
            this.parameterInsert.IdEnterprise=this.selectEnterprise
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
            //this.List_Info()
        },
       
        Insert(){
            var form= {
                IdEnterprise:this.selectEnterprise,
                User : this.$info.email,
                IdDocType: this.SelectIdDocType,
                Columns : this.ListField

            }
            apiWeb.post("DocumentType/SendDocumentServer",form)
                    .then(result=>{
                                if(result.status==0){ 
                                        if(result.value){
                                            this.$msgbox.show(result.message,"Ingresado")
                                            this.List_Info(this.SelectIdDocType)
                                        }
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
         
    }
}
</script>